<script setup>
import { Card, CardContent, CardHeader } from '../../../../../../resources/js/components/ui/card/index.js'
import { Button } from '../../../../../../resources/js/components/ui/button/index.js'
import { computed, ref, watch } from 'vue'
import { useMagicKeys } from '@vueuse/core'
import CustomerOperationCustomIntegration from './CustomerOperations/CustomerOperationCustomIntegration.vue'
import CustomerOperationDispatchMessage from './CustomerOperations/CustomerOperationDispatchMessage.vue'
import CustomerOperationPlaceHolder from './CustomerOperations/CustomerOperationPlaceHolder.vue'
import CustomerOperationScheduleAppointment from './CustomerOperations/CustomerOperationScheduleAppointment.vue'
import CustomerOperationTakeOrder from './CustomerOperations/CustomerOperationTakeOrder.vue'

const nesting = ref(1)
const selectedOption = ref(null)

const selectOption = (option) => {
  selectedOption.value = option
  nesting.value += 1
}

const keys = useMagicKeys()
const optionNumbers = [1, 2, 3, 4, 5, 6]

optionNumbers.forEach((option) => {
  const keyRef = keys[`numpad${option}`]
  watch(keyRef, (pressed, wasPressed) => {
    if (pressed && !wasPressed && nesting.value === 1) {
      selectOption(option)
    }
  })
})

watch(keys.numpad0, (pressed, wasPressed) => {
  if (pressed && !wasPressed && nesting.value > 1) {
    nesting.value -= 1
  }
})

const componentMap = {
  1: CustomerOperationDispatchMessage,
  2: CustomerOperationScheduleAppointment,
  3: CustomerOperationTakeOrder,
  4: CustomerOperationCustomIntegration,
  5: CustomerOperationPlaceHolder,
  6: CustomerOperationPlaceHolder,
}

const selectedComponent = computed(() => {
  const option = selectedOption.value
  if (!option) return null
  return componentMap[option] ?? CustomerOperationPlaceHolder
})

</script>

<template>
  <Card>
    <CardHeader>
      <div>Customer Operations - Nesting <span class="font-bold">{{ nesting }}</span></div>
    </CardHeader>
    <CardContent>
      <div v-if="nesting === 1" class="grid grid-cols-3 gap-2">
        <Button @click="selectOption(1)">
          1. Dispatch Message
        </Button>
        <Button @click="selectOption(2)">
          2. Schedule Meeting
        </Button>
        <Button @click="selectOption(3)">
          3. Take Order
        </Button>
        <Button @click="selectOption(4)">
          4. Something Else
        </Button>
        <Button @click="selectOption(5)">
          5. Even More
        </Button>
        <Button @click="selectOption(6)">
          6. Let's Try it
        </Button>
      </div>
      <div v-if="nesting === 2">
        <div class="mb-4">
          Selected Option: <span class="font-bold">{{ selectedOption }}</span>
        </div>
        <div>
          <component :is="selectedComponent" v-if="selectedComponent" />
        </div>
        <Button @click="nesting -= 1">
          Go Back
        </Button>
      </div>
    </CardContent>
  </Card>
</template>

<style scoped>

</style>
